import { render, staticRenderFns } from "./PageLoading.vue?vue&type=template&id=442a549e&scoped=true"
import script from "./PageLoading.vue?vue&type=script&lang=js"
export * from "./PageLoading.vue?vue&type=script&lang=js"
import style0 from "./PageLoading.vue?vue&type=style&index=0&id=442a549e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442a549e",
  null
  
)

export default component.exports